// src/index.js
import './polyfills'
import React from 'react';
import { render } from 'react-dom';
import { Provider } from 'react-redux'
import createStore from './reducers'
import storeStorage from './reducers/storeStorage'
import './index.css';
import './images/font-awesome-4.7.0/css/font-awesome.min.css';
import whyDidYouRender from '@welldone-software/why-did-you-render'
import App from './App'
import { PersistGate } from 'redux-persist/integration/react'
import { ConnectedRouter } from 'connected-react-router'
//import { Auth0Provider } from '@auth0/auth0-react';
//import { useHistory } from "react-router-dom";


//const history = useHistory();
//const onRedirectCallback = (appState) => {
//    history.push(appState?.returnTo || window.location.pathname);
//};

//const navigate = useNavigate();
const onRedirectCallback = (appState) => {
    history.push(
        appState && appState.returnTo ? appState.returnTo : window.location.pathname
    );
};

//const providerConfig = {
//    domain: 'hrblockcanada-npr.us.auth0.com',
//    clientId: 'mUDJ3CZB94epb0mOjbDg1pt5k8JxdR7D',    
//    redirectUri: window.location.origin + '/callback',    
//    responseType: 'code',
//    scope: 'openid email profile',
//};

let { store, persistor, history } = createStore();
storeStorage.configure(store, persistor, history);

whyDidYouRender(React);

window.onpageshow = function (ev) {
    if (ev.persisted) {
        window.location.reload()
    }
}

render(
    <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
            <ConnectedRouter history={history}>
                {/*<Auth0Provider {...providerConfig}>*/}
                    <App />
                {/*</Auth0Provider>*/}
            </ConnectedRouter>
        </PersistGate>
    </Provider>,
    document.getElementById('root')
)